/**
 * 🏪 ROOT STORE - ניהול מרכזי של כל הסטורים
 * 
 * **ארכיטקטורה חדשה (לאחר רפקטור):**
 * 
 * 📊 **Data Stores** (תיקיית data/):
 * - UiStore - ניהול מצב ממשק המשתמש
 * - ReadingSessionStore - ניהול נתוני קריאה נוכחית
 * 
 * 🎛️ **Controllers** (תיקיית controllers/):
 * - BooksController - ניהול ספרים ובחירות רמות
 * - SpeechRecognitionController - ניהול זיהוי דיבור
 * - TeacherController - ניהול נתוני מורים וכיתות
 * - UserController - ניהול נתוני משתמש
 * - AdminController - ניהול פעולות אדמין
 * 
 * 🔗 **Legacy (עדיין בשימוש):**
 * - TextSourceStore - מקורות טקסט (יועבר בעתיד)
 */

// New architecture imports
import UiStore from "./data/ui.store";
import ReadingSessionStore from "./data/reading-session.store";
import BooksController from "./controllers/books.controller";
import TeacherController from "./controllers/teacher.controller";
import UserController from "./controllers/user.controller";
import AdminController from "./controllers/admin.controller";
import SpeechRecognitionController from "./controllers/speech-recognition.controller";
import SiddurController from "./controllers/siddur.controller";

import { makeAutoObservable } from "mobx";
import { IRootStore, IStores } from "@shared/types";
import { createContext } from "react";

class RootStore implements IRootStore {
  stores: IStores;
  constructor() {
    makeAutoObservable(this);
    const userStore = new UserController(this);
    const teacherStore = new TeacherController(this);
    const uiStore = new UiStore(this);
    const booksStore = new BooksController(this);
    const speechRecognitionStore = new SpeechRecognitionController(this);
    const adminStore = new AdminController(this);
    const readingSessionStore = new ReadingSessionStore(this);
    const siddurStore = new SiddurController(this);

    this.stores = {
      userStore,
      teacherStore,
      uiStore,
      speechRecognitionStore,
      booksStore,
      adminStore,
      readingSessionStore,
      siddurStore,
    };
  }
}

const rootStore = new RootStore();

(window as any).myRS = rootStore;


export const RootStoreContext = createContext(rootStore);
